import {useCallback, useState} from "react"

const read = (key, fallback) => {
    try {
        const raw = window.localStorage.getItem(key)
        return raw === null ? fallback : raw === "true"
    } catch (e) {
        return fallback
    }
}

/**
 * Boolean state persisted in localStorage (e.g. collapsed/expanded panels).
 * Returns [value, toggle, set].
 */
export default function useStoredToggle(key, fallback = false) {
    const [value, setValue] = useState(() => read(key, fallback))

    const set = useCallback((next) => {
        setValue(next)
        try {
            window.localStorage.setItem(key, String(next))
        } catch (e) {
            // storage unavailable — keep in-memory state only
        }
    }, [key])

    const toggle = useCallback(() => set(!value), [set, value])

    return [value, toggle, set]
}
